import React from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
	width: ${props => props.width || '100%'};
	min-width: ${props => props.minWidth};
	display: flex;
	flex-direction: row;
	align-items: center;
	> * {
		flex-grow: 1;
	}
	> .separator {
		flex-grow: 0;
		flex-shrink: 0;
		padding: ${props => props.theme.rangeHyphenPadding || '4px'};
		color: ${props => props.theme.rangeHyphenColor};
		font-size: ${props => props.theme.rangeHyphenFontSize};
		font-weight: ${props => props.theme.rangeHyphenFontWeight};
	}
`;

export default class Range extends React.PureComponent {
	render() {
		return (
			<Wrapper width={this.props.width} minWidth={this.props.minWidth}>
				{this.props.children[0]}
				<span className="separator">-</span>
				{this.props.children[1]}
			</Wrapper>
		)
	}
}
